<style lang="scss">


</style>

<template>
<div class="focused-panel">
  <div class="d-flex centreline-toolbar">
    <!--<div class="p-2">{{wellFeature ? wellFeature.get('ident') : 'No well selected'}}</div>-->
    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Create centreline" :pressed.sync="addEnabled" variant="primary">
      <icon scale=".6" name="plus" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Select centreline" :pressed.sync="selectEnabled" variant="primary">
      <icon scale=".6" name="hand-pointer" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Multi Select" :pressed.sync="multiEdit" variant="primary">
      <icon scale=".6" name="dice-two" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" :id="'undo-'+editorIdent" :disabled="!historyChanges" @click="undo" variant="primary">
      <icon scale=".6" name="undo" />
    </b-btn>
    <b-tooltip v-if="historyChanges" :target="'undo-'+editorIdent" placement="top">
      Undo
    </b-tooltip>


    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit geometry" :disabled="!wellFeatureSelected" :pressed.sync="dragEnabled" variant="primary">
      <icon scale=".6" name="arrows-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" v-b-tooltip.hover.auto title="Edit attributes" :disabled="!wellFeatureSelected" :pressed.sync="editEnabled" variant="primary">
      <icon scale=".6" name="pencil-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" @click="deleteFetaures" v-b-tooltip.hover.auto title="Delete centreline" :disabled="!wellFeatureSelected" variant="primary">
      <icon scale=".6" name="times" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" @click="reverseSelected" :disabled="!wellFeatureSelected" v-b-tooltip.hover.auto title="Reverse">
      <icon scale=".6" name="exchange-alt" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" :pressed.sync="splitEnabled" v-b-tooltip.hover.auto title="Split centreline">
      <icon scale=".6" name="cut" />
    </b-btn>

    <b-btn size="sm" class="dtron-toolbar-button tool1" variant="primary" :disabled="!mergeEnabled" v-b-tooltip.hover.auto title="Merge 2 centrelines" @click="mergeLines">
      <icon scale=".6" name="compress" />
    </b-btn>


    <b-btn size="sm" class="dtron-toolbar-button tool1" :pressed.sync="ldEnabled" v-b-tooltip.hover.auto title="Load dependant layers" variant="primary">
      <icon scale=".6" name="link" />
    </b-btn>
  </div>

  <b-modal v-model="showForm" size="lg" no-close-on-backdrop no-close-on-esc id='centreline-editor-modal'>
    <div slot="modal-header">
      <label>{{formTitle}}</label>
      <div v-if='editablePhase'>
        <div v-if="!featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Lock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if='hoverLock' @click='setLockState(true)'><icon scale=".8" name="lock"/></span>
          <span v-if="!hoverLock"><icon scale=".8" name="unlock"/></span>
        </div>

        <div v-if="featureLock" class='designatron-lock' v-b-tooltip.hover.auto title="Unlock Feature" @mouseover="hoverLock = true" @mouseleave="hoverLock = false">
          <span v-if='hoverLock' @click='setLockState(false)'><icon scale=".8" name="unlock"/></span>
          <span v-if="!hoverLock"><icon scale=".8" name="lock"/></span>
        </div>
      </div>
    </div>

    <div class="p-2">
      <div id='feature-locked-warning' v-if="!editablePhase">
        <b-alert class='user-reminder' variant="warning" show>This feature is locked. It cannot be edited in this Area of responsibility</b-alert>
      </div>
      <div id='feature-locked-warning' v-if="editablePhase && featureLock">
        <b-alert class='user-reminder' variant="warning" show>This feature is locked. Click the unlock button in the upper right to edit feature</b-alert>
      </div>
      <b-form>
        <b-row>
          <!-- <b-col>
            <b-form-group label="Override Ident:">
              <b-form-input @blur.native="vIdent" :state="identState" id="centerlineIdentOverride" :disabled="featureLock" v-model="identOverride" placeholder="Enter override ident"></b-form-input>
              <b-form-invalid-feedback>
                Centreline ident is not unique, change will be ignored
              </b-form-invalid-feedback>
            </b-form-group>
          </b-col> -->
          <b-col>
            <b-form-group label="Route ID:" label-for="route-id">
              <b-form-input id="row-id" :disabled="featureLock" v-model="route_id" placeholder="Enter route id"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Construction Progress:" label-for="construction-progress-type-select">
              <b-form-select :options="cTypeOptions" id="construction-progress-type-select" :disabled="featureLock" v-model="wellAttrs['construction_status']" placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Centreline Type:" label-for="row-type-select" class="row-select">
              <b-form-select :options="rowTypeOptions" id="row-type-select" :disabled="featureLock" v-model="row_type" placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="Gas dest:" label-for="gas-dest-centreline">
              <b-form-input id="gas-dest-centreline" :disabled="featureLock" v-model="gas_dest" placeholder="Enter gas dest"></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group label="LPH:" label-for="lph-centreline">
              <b-form-select :options="lphOptions" id="lph-centreline" :disabled="featureLock" v-model="lph" placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Row Width:" label-for="row-width-select" class="row-select">
              <b-form-select :options="rowOptions" id="row-width-select" :disabled="featureLock" v-model="row" placeholder="Please, select option"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Cable Asset Tag:" label-for="cable-asset-tag" class="row-select">
              <b-form-input id="cable-asset-tag" :disabled="featureLock" v-model="cable_asset_tag" placeholder="Enter cable asset tag"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Comment:" label-for="centrelineComment">
              <b-textarea id="centrelineComment" :disabled="featureLock" v-model="wellAttrs['comment']" rows="3"></b-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div v-if="isToolEnabled('update_from_survey') && !featureLock" id="update-survey-container">
              <b-btn size="sm" @click="surveyUpdate" v-b-tooltip.hover title='Update geometry from survey based on matching idents'>
                Update from survey
              </b-btn>
            </div>
          </b-col>
        </b-row>
        <hr>
          <strong>KEGS Generated Pipes</strong>

          <b-row>
            <b-col>
              <b-row v-if="defaultPipes.length > 0" v-for="(pipe, i) in defaultPipes" :key="'default-pipes-' +i">

                  <b-col cols='2'>
                    <b-form-group label="Pipe Type" class="row-select">
                      <b-form-input disabled v-model="pipe['pipeline_type']"  v-b-tooltip.hover title='Default pipe type' placeholder="No valid type found"></b-form-input>
                    </b-form-group>
                  </b-col>
                  <b-col>
                    <b-form-group label="Pipe Size" class="row-select">
                      <b-form-input disabled v-model="pipe['subject']"  v-b-tooltip.hover title='Default pipe size' placeholder="No valid size found"></b-form-input>
                    </b-form-group>
                  </b-col>
              </b-row>
              <b-row v-if="defaultPipes.length == 0" class="mb-1">
                  <b-col>
                    <span>There are KEGS generated pipes for this centreline</span>
                  </b-col>
              </b-row>
            </b-col>
          </b-row>
          <b-form-checkbox :unchecked-value="false" :value="true" v-model="nopipes_gas" size="sm">No KEGS generated gas pipes</b-form-checkbox>
          <b-form-checkbox :unchecked-value="false" :value="true" v-model="nopipes_water" size="sm">No KEGS generated water pipes</b-form-checkbox>
        <hr>

        <b-row class='overide-container'>
          <b-col>
            <strong>Gas pipes overrides</strong>
            <div v-if="pipes.gas" v-for="(pipe, i) in pipes.gas" :key="'gas-override-' +i" class="mt-2">
              <b-row>
                <b-col cols='5'>
                  <b-form-select :options="gasOverideOptions" :id="'gasOveride'+i" :disabled="featureLock" v-model="pipe['lib']" required placeholder="Please, select option" v-b-tooltip.hover title='Gas pipe type'></b-form-select>
                </b-col>
                <b-col cols='2'>
                  <b-form-input :disabled="featureLock" v-model="pipe['offset']" placeholder="Metre Offset" v-b-tooltip.hover title='Metre offset'></b-form-input>
                </b-col>
                <b-col cols='3'>
                  <b-form-input :disabled="featureLock" v-model="pipe['name']" :state="pipeNameState(pipe['name'], 'pg-'+ i)" placeholder="Name" v-b-tooltip.hover title='Name'></b-form-input>
                </b-col>
                <!-- <b-col cols='3'>
                  <b-form-input :disabled="featureLock" v-model="pipe['line_number']" placeholder="Tag Number" v-b-tooltip.hover title='Tag number'></b-form-input>
                </b-col> -->
                <b-col cols='2'>
                  <b-btn size="sm" v-b-tooltip.hover title="Reverse" :pressed.sync="pipe['reverted']">
                    <icon scale=".6" name="exchange-alt" />
                  </b-btn>
                  <b-btn size="sm" v-b-tooltip.hover title="Delete" @click="deletePipe($event, 'gas', pipe)">
                    <icon scale=".6" name="minus" />
                  </b-btn>
                </b-col>
              </b-row>
            </div>
            <b-btn size="sm" class="mt-2" :disabled="featureLock" @click="addPipe($event, 'gas')" v-b-tooltip.hover title='Add gas pipe'>
              <icon scale=".6" name="plus" />
            </b-btn>
          </b-col>
        </b-row>
        <hr>
        <b-row>
          <b-col>
            <strong>Water pipes overrides</strong>
            <div v-if="pipes.water" v-for="(pipe, i) in pipes.water" :key="'water-override-' +i" class="mt-2">
              <b-row>
                <b-col cols='5'>
                  <b-form-select :options="waterOverideOptions" :id="'waterOveride'+i" :disabled="featureLock" v-model="pipe['lib']" required placeholder="Please, select option" v-b-tooltip.hover title='Water pipe type'></b-form-select>
                </b-col>
                <b-col cols='2'>
                  <b-form-input :disabled="featureLock" v-model="pipe['offset']" placeholder="Offset" v-b-tooltip.hover title='Metre offset'></b-form-input>
                </b-col>
                <b-col cols='3'>
                  <b-form-input :disabled="featureLock" v-model="pipe['name']" :state="pipeNameState(pipe['name'], 'pw-'+ i)" placeholder="Name" v-b-tooltip.hover title='Name'></b-form-input>
                </b-col>
                <!-- <b-col cols='3'>
                  <b-form-input :disabled="featureLock" v-model="pipe['line_number']" placeholder="Tag Number" v-b-tooltip.hover title='Tag number'></b-form-input>
                </b-col> -->
                <b-col cols='2'>
                  <b-btn size="sm" class="mt-2" v-b-tooltip.hover title="Reverse" :pressed.sync="pipe['reverted']">
                    <icon scale=".6" name="exchange-alt" />
                  </b-btn>
                  <b-btn size="sm" class="mt-2" v-b-tooltip.hover title="Delete" @click="deletePipe($event, 'water', pipe)">
                    <icon scale=".6" name="minus" />
                  </b-btn>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col>
                  <b-form-checkbox :unchecked-value="false" :value="true" v-model="pipe['bidirectional']" size="sm">Bidirectional Pipe</b-form-checkbox>
                </b-col>
              </b-row>
            </div>
            <b-btn size="sm" :disabled="featureLock" class="mt-2" @click="addPipe($event, 'water')" v-b-tooltip.hover title='Add water pipe'>
              <icon scale=".6" name="plus" />
            </b-btn>
          </b-col>
        </b-row>
      </b-form>
    </div>
    <div slot="modal-footer" class="designatron-modal-footer">
      <b-row>
        <b-col>
          <div role="group" class="btn-group">
            <b-btn size="sm" class="float-right" variant="primary" @click="close">
              Close
            </b-btn>
            <b-btn size="sm" :disabled="featureLock || invalidPipes.length > 0" class="float-right" variant="success" @click="onOK">
              Save
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>

</div>
</template>

<script>
import FeatureEditorMixin from '../../../mixins/FeatureEditorMixin'
import 'vue-awesome/icons/list-ol'
import 'vue-awesome/icons/cut'
import 'vue-awesome/icons/compress'
import 'vue-awesome/icons/hand-pointer'
import 'vue-awesome/icons/undo'
import 'vue-awesome/icons/exchange-alt'
import 'vue-awesome/icons/bezier-curve'
import 'vue-awesome/icons/pencil-alt'
import 'vue-awesome/icons/times'
import 'vue-awesome/icons/clock'
import 'vue-awesome/icons/backward'
import 'vue-awesome/icons/lock'
import 'vue-awesome/icons/unlock'
import 'vue-awesome/icons/dice-two'
import Feature from 'ol/Feature'
import uuidV1 from 'uuid/v1'
import Vue from 'vue'
import { parallel } from 'async'

export default {
  name: 'centreline-editor',
  components: {},
  mixins: [FeatureEditorMixin],
  data() {
    return {
      pipes: {
        gas: null
          /*[{
                      lib: 0,
                      offset: 2,
                      reverted: false,
                      name: '',
                      line_number: '',
                      id: 1
                    }]*/
          ,
        water: null
          /*[{
                      lib: 0,
                      offset: 4,
                      reverted: false,
                      name: '',
                      line_number: '',
                      id: 1
                    }]*/
          ,
      },
      identOverride: null,
      nopipes: false,
      // TODO above nopipes attr is old but UI needs to handle it
      nopipes_gas: false,
      nopipes_water: false,
      identState: null,
      waterOverideOptions: [],
      rowOptions: [],
      cTypeOptions: [
        'concept',
        'surveyed',
        'design',
        'asbuilt'
      ],
      lph: 'No',
      lphOptions: [
        'Yes',
        'No',
      ],
      rowTypeOptions: [],
      row: 0,
      row_type: 0,
      route_id: null,
      gas_dest: null,
      cable_asset_tag: null,
      gasOverideOptions: [],
      items: [],
      wellAttrs: {
        ident: null,
        comment: '',
        centreline_type: '',
        construction_status: '',
        gas_dest: '',
        lph: null
      },
      geomType: 'LineString',
      wellLayerName: 'v4:centreline',
      mergeEnabled: false,
      multiEdit: false,
      hoverLock: false,
      lockable: true,
      schema: 'centreline',
      initialIdent: null,
      invalidPipes: [],
      defaultPipes: []
    }
  },
  created() {
    this.selectTool = null
  },
  methods: {

    pipeNameState (name, id) {
      let nongathering = ['interconnect', 'transfer', 'mp', 'shared']
      if (name === "" && nongathering.includes(this.wellAttrs['centreline_type'])) {
        if (!this.invalidPipes.includes(id)) {
          this.invalidPipes.push(id)
        }
        return false
      } else {
        if (this.invalidPipes.includes(id)) {
          this.invalidPipes = this.invalidPipes.filter(p => p !== id)
        }
        return null
      }
    },
    surveyUpdate() {
      this.updateFeatureFromSurvey()
      this.close()
    },
    close(evt) {
      this.wellFeature = null
      this.showForm = false
      this.onCancel()
    },
    resetGasPipes() {
      if (confirm('If you proceed all custom gas pipe overrrides will be removed. Reset?')) {
        this.pipes.gas = null
        this.packOverrides()
      }
    },
    resetWaterPipes() {
      if (confirm('If you proceed all custom water pipe overrrides will be removed. Reset?')) {
        this.pipes.water = null
        this.packOverrides()
      }
    },
    deletePipe(e, pipeType, pipe) {
      let pipes

      if (pipeType === 'gas') {
        pipes = this.pipes.gas
      } else {
        pipes = this.pipes.water
      }

      let index = pipes.map(p => p.id).indexOf(pipe.id)
      if (index > -1) {
        pipes.splice(index, 1)
      }
    },
    addPipe(e, pipeType) {
      let d = {
        lib: 0,
        reverted: false,
        name: '',
        line_number: '',
        bidirectional: false
      }

      let pipes

      if (pipeType === 'gas') {
        if (this.pipes.gas === null) {
          Vue.set(this.pipes, 'gas', [])
        }
        pipes = this.pipes.gas
        d['offset'] = pipes.length > 0 ? pipes.length * 2 : 2
      } else {
        if (this.pipes.water === null) {
          Vue.set(this.pipes, 'water', [])
        }
        pipes = this.pipes.water
        d['offset'] = pipes.length > 0 ? pipes.length * 2 : 4
      }
      d['id'] = pipes.length + 1
      pipes.push(d)
    },
    reverseSelected() {
      let lines = this.selectInteraction.getFeatures().getArray()
      lines.forEach(line => {
        line.getGeometry().setCoordinates(line.getGeometry().getCoordinates().reverse())
      })
      this._edit(lines)
      this.selectInteraction.getFeatures().clear()
    },

    parseOverrides() {
      let overrides
      if (this.wellFeature && this.wellFeature.get('overrides')) {
        try {
          overrides = JSON.parse(this.wellFeature.get('overrides'))
        } catch (e) {
          console.log('ERROR: could not parse centrelines overrides')
        }
      }
      if (overrides) {
        // console.log(overrides)
        if (overrides.ident) {
          this.identOverride = overrides.ident
        } else {
          this.identOverride = null
        }

        if (overrides.nopipes_gas) {
          this.nopipes_gas = overrides.nopipes_gas
        } else {
          this.nopipes_gas = false
        }

        if (overrides.nopipes_water) {
          this.nopipes_water = overrides.nopipes_water
        } else {
          this.nopipes_water = false
        }

        if (overrides.nopipes) {
          this.nopipes = overrides.nopipes
          if (this.nopipes) {
            this.nopipes_gas = true
            this.nopipes_water = true
          }
        } else {
          this.nopipes = false
        }

        if (overrides.route_id) {
          this.route_id = overrides.route_id
        } else {
          this.route_id = null
        }
        if (overrides.row) {
          this.row = overrides.row
        } else {
          this.row = 0
        }
        if (overrides.cable_asset_tag) {
          this.cable_asset_tag = overrides.cable_asset_tag
        } else {
          this.cable_asset_tag = null
        }
        if (overrides.row_type) {
          this.row_type = overrides.row_type
        } else {
          this.row_type = this.rowTypeOptions.find(o => o.text.toLowerCase() == this.wellAttrs['centreline_type'].toLowerCase()).value
        }
        if (overrides.gas_pipes && overrides.gas_pipes.length > 0) {
          this.pipes.gas = overrides.gas_pipes
        } else {
          this.pipes.gas = null
        }
        if (overrides.water_pipes && overrides.water_pipes.length > 0) {
          this.pipes.water = overrides.water_pipes
        } else {
          this.pipes.water = null
        }

        if (overrides.gas_dest) {
          this.gas_dest = overrides.gas_dest
        } else {
          this.gas_dest = this.wellAttrs['gas_dest']
        }
      } else {
        this.resetOverrides()
      }
    },
    resetOverrides () {
      this.row = 0
      if (this.rowTypeOptions.length > 0 && this.wellAttrs['centreline_type']) {
        this.row_type = this.rowTypeOptions.find(o => o.text.toLowerCase() == this.wellAttrs['centreline_type'].toLowerCase()).value
      } else {
        this.row_type = 0
      }

      this.identOverride = null
      this.route_id = null
      this.gas_dest = null
      this.pipes['gas'] = null
      this.pipes['water'] = null
      this.initialIdent= null
      this.nopipes= false
      this.nopipes_gas= false
      this.nopipes_water= false
      this.invalidPipes= []
    },
    packOverrides() {
      let overrides = {}
      if (this.wellFeature && this.wellFeature.get('overrides')) {
        try {
          overrides = JSON.parse(this.wellFeature.get('overrides'))
        } catch (e) {
          console.log('ERROR: could not parse centrelines overrides')
        }
      }
      if (!overrides) {
        overrides = {}
      }
      if (this.pipes.gas) {
        overrides['gas_pipes'] = this.pipes.gas.filter(p => p.lib)
      }

      if (this.pipes.water) {
        overrides['water_pipes'] = this.pipes.water.filter(p => p.lib)
      }

      overrides['route_id'] = this.route_id || undefined
      overrides['gas_dest'] = this.gas_dest || undefined

      overrides['cable_asset_tag'] = this.cable_asset_tag || undefined

      overrides['row'] = this.row || undefined

      overrides['row_type'] = this.row_type || undefined

      // Phasing out nopipes updated into two seperate options
      if (overrides['nopipes']) {
        delete overrides['nopipes']
      }
      overrides['nopipes_water'] = this.nopipes_water
      overrides['nopipes_gas'] = this.nopipes_gas


      // TODO clean
      // currently if multiple features selected, pacakge directly features in select interaction
      if (this.selectInteraction.getFeatures().getArray().length > 1) {
        this.selectInteraction.getFeatures().getArray().forEach(ff => {
          ff.set('overrides', JSON.stringify(overrides))
        })
      } else {
        this.wellAttrs['overrides'] = JSON.stringify(overrides)
      }
    },
    loadOverides(clb) {

      parallel([
        (c) => {
          this.$http.get('/api/layers/gas-overide-options').then(res => {
            let fil = res.body.filter(f => f.subject)
            this.gasOverideOptions = fil.map(m => {
              return {
                text: m.subject,
                value: m.id
              }
            })
            c(null)

          }, res => {
            c(res)
            console.log('Error Thrown')
            console.log(res)
          })
        },
        (c) => {
          this.$http.get('/api/layers/water-overide-options').then(res => {
            let fil = res.body.filter(f => f.subject)
            this.waterOverideOptions = fil.map(m => {
              return {
                text: m.subject,
                value: m.id
              }
            })
            this.waterOverideOptions = this.waterOverideOptions.concat({
              text: 'None',
              value: 0
            })

            c(null)

          }, res => {
            c(res)
            console.log('Error Thrown')
            console.log(res)
          })
        }

      ], (e) => {
        clb && clb.call(this)
      })

    },
    loadDefaultPipes(clb) {
      if (this.wellFeature) {
        this.$http.get('/api/layers/default-pipes', {
          params: {
            workpack_id: this.currentProject.workpack.id,
            centreline_id: this.wellFeature.get('id')
          }
        }).then(res => {
          this.defaultPipes = res.body
          clb(null)

        }, res => {
          clb(res)
          console.log('Error Thrown')
          console.log(res)
        })
      } else {
        clb(null)
      }

    },
    loadRows(clb) {
      parallel ([
        (c) => {
          this.$http.get('/api/layers/row-options').then(res => {
            let fil = res.body.filter(f => f.subject)
            this.rowOptions = fil.map(m => {
              return {
                text: m.subject,
                value: m.id
              }
            })
            this.rowOptions = this.rowOptions.concat({
              text: 'None',
              value: 0
            })
            c(null)
          }, res => {
            c(res)
            console.log('Error Thrown')
            console.log(res)
          })
        },
        (c) => {
          this.$http.get('/api/layers/row-type-options').then(res => {
            let fil = res.body.filter(f => f.subject)
            this.rowTypeOptions = fil.map(m => {
              return {
                text: m.subject,
                value: m.id
              }
            })
            if (this.row_type == 0 && this.wellAttrs['centreline_type']) {
              this.row_type = this.rowTypeOptions.find(o => o.text.toLowerCase() == this.wellAttrs['centreline_type'].toLowerCase()).value
            }
            c(null)
          }, res => {
            c(res)
            console.log('Error Thrown')
            console.log(res)
          })
        }
      ], (err) => {
        clb && clb.call(this)
      })

    }
  },
  watch: {
    countSelectedFeatures(val) {
      this.mergeEnabled = val === 2
    },
    identOverride(val) {
      if (!this.initialIdent) {
        this.initialIdent = val
      }
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    route_id(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    nopipes(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    nopipes_water(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    nopipes_gas(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    gas_dest(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    cable_asset_tag(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    lph(val) {
      if (this.lph && this.lph !== this.wellAttrs['lph']) {
        this.wellAttrs['lph'] = val == 'Yes' ? true : false
      }
    },
    showForm(val) {

      this.initialIdent=this.wellAttrs[this.identName ? this.identName : 'ident'] || null

      // this.parseOverrides()
      parallel([
        (c) => this.loadOverides(c),
        (c) => this.loadRows(c),
        (c) => this.loadDefaultPipes(c)
      ], (e) => {
        if (val) {
          this.parseOverrides()
          if (!this.wellAttrs['construction_status']) {
            this.wellAttrs['construction_status'] = 'concept'
          }
          this.lph = this.wellAttrs['lph'] ? 'Yes' : 'No'
          if (this.lph && this.lph !== this.wellAttrs['lph']) {
            this.wellAttrs['lph'] = this.lph == 'Yes' ? true : false
          }
        } else {
          this.identState = null
        }
      })

      if (!val) {
        this.resetOverrides()
      }

    },
    wellAttrs: {
      handler(val) {
        if (!this.initialIdent) {
          this.initialIdent = this.identOverride
        }
      },
      deep: true
    },
    pipes: {
      handler(val) {
        this.packOverrides()
      },
      deep: true
    },
    row(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    },
    row_type(val) {
      if (this.wellFeature) {
        this.packOverrides()
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/map/designotron/CentrelineEditor.vue